import React, { useState, useEffect, useRef } from 'react';
import { getYears } from '../../utils/constCodeUtils';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Divider,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from '@mui/material';
import * as xlsx from 'xlsx';
import AskDialog from '../../components/common/dialog/AskDialog';
import CollectsBuysStaticsHeadquarterContainer from './CollectsBuysStaticsHeadquarterContainer';
import CollectsBuysStaticsTeamContainer from './CollectsBuysStaticsTeamContainer';
import CollectsBuysStaticsEmployeeContainer from './CollectsBuysStaticsEmployeeContainer';

//------------------------------------------------------------------
const staticsTypes = [
  { name: '본부', type: 'headquarter' },
  { name: '팀', type: 'depart' },
  { name: '팀원', type: 'employee' },
];

const prjTypOptions = [
  { value: 'A', name: '전체' },
  { value: 'N', name: '프로젝트' },
  { value: 'M', name: '유지보수' },
  { value: 'ETC', name: '기타매출' },
];

const staticsOptions = [
  { name: '수금', value: 'sales' },
  { name: '지급', value: 'buy' },
];
//------------------------------------------------------------------
const arrYears = getYears(3, 1);
const arrMonths = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
];

const CollectsBuysStaticsContainer = () => {
  const hqTableRef = useRef();
  const dpTableRef = useRef();
  const empTableRef = useRef();

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedStrMonth, setSelectedStrMonth] = useState('01');
  const [selectedEndMonth, setSelectedEndMonth] = useState('12');
  const [searchDate, setSearchDate] = useState(null);

  const [type, setType] = useState('headquarter');
  const [searchPrjTyp, setSearchPrjTyp] = useState('A');
  const [selectedGbn, setSelectedGbn] = useState('sales');

  const handleChangeType = (event, newType) => {
    if (newType === '' || newType === null) {
      newType = 'headquarter';
    }
    setType(newType);
    searchClickHandler();
  };

  const handleChangePrjTyp = (event, newPrjTyp) => {
    if (newPrjTyp === '' || newPrjTyp === null) {
      newPrjTyp = 'A';
    }
    setSearchPrjTyp(newPrjTyp);
    searchClickHandler();
  };

  const handleChangeGbn = (event, newGbn) => {
    if (newGbn === '' || newGbn === null) {
      newGbn = 'sales';
    }
    setSelectedGbn(newGbn);
    searchClickHandler();
  };

  const handleDownExcel = () => {
    let el;
    let name;
    if (type === 'headquarter') {
      el = hqTableRef;
      name = '본부';
    } else if (type === 'depart') {
      el = dpTableRef;
      name = '팀';
    } else if (type === 'employee') {
      el = empTableRef;
      name = '팀원';
    }
    htmlToExcel(el.current, name);
  };

  const htmlToExcel = (tableEl, name) => {
    const wb = xlsx.utils.table_to_book(tableEl, {
      sheet: 'sheet1',
      raw: true,
    });
    xlsx.writeFile(wb, name + '.xlsx');
  };

  const checkValid = () => {
    let valid = true;
    if (parseInt(selectedStrMonth) > parseInt(selectedEndMonth)) {
      valid = false;
    }

    return valid;
  };

  useEffect(() => {
    if (
      type &&
      searchPrjTyp &&
      selectedGbn &&
      selectedYear &&
      selectedStrMonth &&
      selectedEndMonth
    ) {
      setSearchDate(
        type +
          '_' +
          searchPrjTyp +
          '_' +
          selectedGbn +
          '_' +
          selectedYear +
          '-' +
          selectedStrMonth +
          '~' +
          selectedEndMonth,
      );
    }
  }, []);

  const searchClickHandler = () => {
    const valid = checkValid();
    if (!valid) {
      setVisible(true);
      return;
    }
    setSearchDate(
      type +
        searchPrjTyp +
        '_' +
        selectedGbn +
        '_' +
        selectedYear +
        '-' +
        selectedStrMonth +
        '~' +
        selectedEndMonth,
    );
  };

  const [visible, setVisible] = useState(false);
  const onCancle = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    setVisible(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box sx={{ minWidth: 100, mx: 0.5 }}>
            <FormControl variant="standard" size="small" fullWidth>
              <Select
                labelId="selected-year-label"
                id="selected-year"
                value={selectedYear}
                displayEmpty
                label="년도"
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {arrYears &&
                  arrYears.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ mx: 0.5 }}>
            <Typography variant="subtitle2">년</Typography>
          </Box>
          <Box sx={{ minWidth: 80, mx: 0.5 }}>
            <FormControl variant="standard" size="small" fullWidth>
              <Select
                labelId="start-month-label"
                id="selected-month"
                value={selectedStrMonth}
                displayEmpty
                label="시작월"
                onChange={(e) => setSelectedStrMonth(e.target.value)}
              >
                {arrMonths.map((month) => (
                  <MenuItem key={month} value={month}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ mx: 0.5 }}>
            <Typography variant="subtitle2">월부터</Typography>
          </Box>
          <Box sx={{ minWidth: 80, mx: 0.5 }}>
            <FormControl variant="standard" size="small" fullWidth>
              <Select
                labelId="end-month-label"
                id="end-month"
                value={selectedEndMonth}
                displayEmpty
                label="종료월"
                onChange={(e) => setSelectedEndMonth(e.target.value)}
              >
                {arrMonths.map((month) => (
                  <MenuItem
                    key={month}
                    value={month}
                    disabled={parseInt(selectedStrMonth) > parseInt(month)}
                  >
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ mx: 0.5 }}>
            <Typography variant="subtitle2">까지</Typography>
          </Box>
          <Box sx={{ ml: 2, mr: 1 }}>
            <FormControl>
              <FormLabel id="prjTyp-radion-label">매출 타입</FormLabel>
              <RadioGroup
                row
                aria-labelledby="prjTyp-radion-label"
                name="prjTyp-group"
                value={searchPrjTyp}
                onChange={handleChangePrjTyp}
              >
                {prjTypOptions &&
                  prjTypOptions.map((option, index) => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={<Radio />}
                      label={option.name}
                    />
                  ))}
              </RadioGroup>
            </FormControl>
          </Box>

          <Box sx={{ mx: 1 }}>
            <FormControl>
              <FormLabel id="gbn-radion-label">구분</FormLabel>
              <RadioGroup
                row
                aria-labelledby="gbn-radion-label"
                name="gbn-group"
                value={selectedGbn}
                onChange={handleChangeGbn}
              >
                {staticsOptions &&
                  staticsOptions.map((option, index) => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={<Radio />}
                      label={option.name}
                    />
                  ))}
              </RadioGroup>
            </FormControl>
          </Box>

          <Box sx={{ mx: 1 }}>
            <ToggleButtonGroup
              size="small"
              color="primary"
              value={type}
              exclusive
              onChange={handleChangeType}
            >
              {staticsTypes.map((type, index) => (
                <ToggleButton key={index} value={type.type}>
                  {type.name}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box sx={{ mx: 1 }}>
            <Button
              variant="contained"
              color="info"
              onClick={searchClickHandler}
            >
              검색
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              color="success"
              onClick={handleDownExcel}
            >
              엑셀 다운로드
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />

      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {type === 'headquarter' && (
          <CollectsBuysStaticsHeadquarterContainer
            selectedYear={selectedYear}
            strMonth={selectedStrMonth}
            endMonth={selectedEndMonth}
            selectPrjTyp={searchPrjTyp}
            selectedGbn={selectedGbn}
            searchDate={searchDate}
            tableRef={hqTableRef}
          />
        )}
        {type === 'depart' && (
          <CollectsBuysStaticsTeamContainer
            selectedYear={selectedYear}
            strMonth={selectedStrMonth}
            endMonth={selectedEndMonth}
            searchDate={searchDate}
            selectPrjTyp={searchPrjTyp}
            selectedGbn={selectedGbn}
            tableRef={dpTableRef}
          />
        )}
        {type === 'employee' && (
          <CollectsBuysStaticsEmployeeContainer
            selectedYear={selectedYear}
            strMonth={selectedStrMonth}
            endMonth={selectedEndMonth}
            selectPrjTyp={searchPrjTyp}
            searchDate={searchDate}
            selectedGbn={selectedGbn}
            tableRef={empTableRef}
          />
        )}
      </Box>
      <AskDialog
        visible={visible}
        title="검색 오류"
        description="잘못된 검색기간이 설정되었습니다. 검색기간을 확인하세요"
        confirmText="확인"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </Box>
  );
};
export default CollectsBuysStaticsContainer;
